import React from 'react';
import { Button } from './ui/Button';
export function BonusSection() {
  const handleScrollToPricing = () => {
    window.location.href = 'https://checkout.recursostop.shop/cart/45775377465540:1';
  };
  return <section className="py-16 md:py-20 bg-[#3D1F2E] text-white" data-id="element-20">
      <div className="max-w-6xl mx-auto px-4" data-id="element-21">
        <div className="text-center mb-10 md:mb-16" data-id="element-22">
          <h2 className="text-2xl md:text-5xl font-black mb-3 md:mb-4 uppercase tracking-tight" data-id="element-23">
            🎁 <span className="gold-title" data-id="element-24">BONOS ESPECIALES — GRATIS HOY</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-300" data-id="element-25">
            Llevate estos 3 complementos estratégicos sin costo adicional
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-10 md:mb-16" data-id="element-26">
          {[{
          img: 'https://cdn.magicpatterns.com/uploads/3q7YXgnJe4GPwxkUdUBJhx/ChatGPT_Image_13_feb_2026,_20_10_58.png',
          title: 'Bono #1 – Asesoría de Imagen Profesional',
          desc: 'Elevá tu presencia y ofrecé un servicio premium.'
        }, {
          img: 'https://cdn.magicpatterns.com/uploads/aXHS4VvS3TncoW1YXe6HdJ/ChatGPT_Image_13_feb_2026,_20_08_34.png',
          title: 'Bono #2 – Colorimetría Aplicada',
          desc: 'Aprendé a elegir colores correctos para cada cliente.'
        }, {
          img: 'https://cdn.magicpatterns.com/uploads/eHRNLRGEXuRwALBBqCN97k/ChatGPT_Image_13_feb_2026,_20_06_09.png',
          title: 'Bono #3 – Depilación con Hilo',
          desc: 'Técnica precisa, económica y altamente rentable.'
        }].map((bonus, idx) => <div key={idx} className="bg-[#2D1520] rounded-xl overflow-hidden border border-[#5A3045] hover:border-purple-400 transition-colors duration-300 flex flex-col cursor-pointer" onClick={handleScrollToPricing} data-id="element-27">
              <div className="aspect-square w-full relative overflow-hidden" data-id="element-28">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover" data-id="element-29" />
                <div className="absolute top-4 right-4 bg-gradient-to-r from-[#C084FC] to-[#E879F9] text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg transform rotate-3" data-id="element-30">
                  GRATIS
                </div>
              </div>
              <div className="p-4 md:p-6 flex-1 flex flex-col" data-id="element-31">
                <h4 className="text-base md:text-lg font-bold text-white mb-2" data-id="element-32">
                  {bonus.title}
                </h4>
                <p className="text-gray-400 text-sm mb-4 flex-1" data-id="element-33">
                  {bonus.desc}
                </p>
                <div className="pt-4 border-t border-[#5A3045]" data-id="element-34">
                  <p className="text-sm text-gray-400" data-id="element-35">
                    Valor real:{' '}
                    <span className="line-through decoration-purple-400" data-id="element-36">
                      ARS $19.990
                    </span>
                  </p>
                  <p className="text-xl font-bold text-green-400" data-id="element-37">
                    HOY: GRATIS
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-38">
          <Button onClick={handleScrollToPricing} variant="secondary" size="xl" className="animate-pulse" data-id="element-39">
            🔥 QUIERO TRANSFORMAR MI FUTURO AHORA
          </Button>
          <div className="flex items-center justify-center gap-4 mt-6 opacity-70" data-id="element-40">
            <img src="https://cdn.magicpatterns.com/uploads/fL9kACheWktd2dhJwcnkzQ/mercado_pago.jpg" alt="Mercado Pago" className="h-8 rounded" data-id="element-41" />
          </div>
        </div>
      </div>
    </section>;
}